// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-a329a89e] {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n}\n.container[data-v-a329a89e] .header {\n  top: 0;\n}\n.container[data-v-a329a89e] .lengend {\n  top: 1.0625rem;\n}\n.container .iframe[data-v-a329a89e] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
